import React from 'react'

import Header from '~components/Header'
import Footer from '~components/Footer'

import WorkHero from '~components/pages/work/Hero'

import CaseStudies from '~components/pages/work/CaseStudies'
import GetInTouch from '~components/pages/about/GetInTouch'

const WorkPageWrap = ({ data, isPreview }) => {
  return (
    <>
      <Header isPreview={isPreview} />
      <WorkHero data={data.hero} isPreview={isPreview} />
      {!isPreview && <CaseStudies data={data.works} isPreview={isPreview} />}
      {isPreview && <div style={{textAlign: 'center', padding: '80px'}}>The list of case studies will be displayed here.</div>}
      {/* @TODO: create similar get in touch component but full width or have props */}
      <GetInTouch data={data.get_in_touch} isPreview={isPreview} />
      <Footer isPreview={isPreview} />
    </>
  )
}

export default WorkPageWrap
